export const WIDGETS_DEMO_STORAGE_KEY = "widgets-demo-active-views";

export const WIDGET_VIEWS = ["all", "weather", "tube", "transactions"];

export const readActiveViews = () => {
  try {
    const storedValue = localStorage.getItem(WIDGETS_DEMO_STORAGE_KEY);

    if (!storedValue) {
      return null;
    }

    const parsedValue = JSON.parse(storedValue);

    if (!Array.isArray(parsedValue)) {
      return null;
    }

    const filteredViews = parsedValue.filter((view) =>
      WIDGET_VIEWS.includes(view)
    );

    return filteredViews.length ? filteredViews : null;
  } catch (error) {
    return null;
  }
};

export const saveActiveViews = (views) => {
  const sanitizedViews = views.filter((view) => WIDGET_VIEWS.includes(view));
  localStorage.setItem(WIDGETS_DEMO_STORAGE_KEY, JSON.stringify(sanitizedViews));
};
